import phoebe_waving from'../images/phoebe_waving.png'
import phoebe_neutral from'../images/phoebe_neutral.png'
import phoebe_laughing from'../images/phoebe_laughing.png'
import phoebe_smiling from'../images/phoebe_smiling.png'
import phoebe_sittingDisgusted from'../images/phoebe_sittingDisgusted.png'
import phoebe_sittingCoffeeShocked from'../images/phoebe_shokedCoffee.png'
import phoebe_sittingAngry from'../images/phoebe_sittingAngry.png'
import phoebe_sittingNeutralCoffee from'../images/phoebe_sittingNeutralCoffee.png'
import phoebe_sittingQuestionCoffee from'../images/phoebe_sittingQuestionCoffee.png'
import phoebe_sittingLaughingCoffee from'../images/phoebe_sittingLaughingCoffee.png'
import phoebe_sittingSmilingCoffee from'../images/phoebe_sittingSmilingCoffee.png'
import phoebe_sittingDisgustedCoffee from'../images/phoebe_sittingDisgustedCoffee.png'
import phoebe_sittingSurprisedCoffee from'../images/phoebe_sittingSurprisedCoffee.png'
import phoebe_sittingThinkingCoffee from'../images/phoebe_sittingThinkingCoffee.png'
import phoebe_sittingSnideCoffee from'../images/phoebe_sittingSnideCoffee.png'
import phoebe_sittingThinkingBlushedCoffee from'../images/phoebe_sittingThinkingBlushedCoffee.png'
import phoebe_sittingSadCoffee from'../images/phoebe_sittingSadCoffee.png'
import phoebe_sittingAngryTearsCoffee from'../images/phoebe_sittingAngryTearsCoffee.png'
import phoebe_sittingFrustratedTearsCoffee from'../images/phoebe_sittingFrustratedTearsCoffee.png'
import phoebe_sittingSadTearsCoffee from'../images/phoebe_sittingSadTearsCoffee.png'
import phoebe_standingNeutralWild from'../images/phoebe_standingNeutralWild.png'
import phoebe_standingLaughingWild from'../images/phoebe_standingLaughingWild.png'
import phoebe_standingFrustratedWild from'../images/phoebe_standingFrustratedWild.png'
import phoebe_standingSmilingWild from'../images/phoebe_standingSmilingWild.png'
import phoebe_standingEyebrowUpWild from'../images/phoebe_standingEyebrowUpWild.png'
import phoebe_standingEmbarassedWild from'../images/phoebe_standingEmbarassedWild.png'
import phoebe_standingThinkingWild from'../images/phoebe_standingThinkingWild.png'
import phoebe_standingEyebrowUpNeutralWild from'../images/phoebe_standingEyebrowUpNeutralWild.png'
import willie from'../images/willie_neutral.png'
import willie_snide from'../images/willie_snide.png'
import willie_disgust from'../images/willie_disgust.png'
import willie_surprised from'../images/willie_surprised.png'
import willie_sittingNeutral from'../images/willie_sittingNeutral.png'
import willie_sittingQuestion from'../images/willie_sittingQuestion.png'
import willie_sittingSurprised from'../images/willie_sittingSurprised.png'
import willie_sittingLookingToTheSide from'../images/willie_sittingLookingToTheSide.png'
import willie_sittingSweating from'../images/willie_sittingSweating.png'
import willie_sittingSnide from'../images/willie_sittingSnide.png'
import willie_neutralSquirt from'../images/willie_neutralSquirt.png'
import willie_watchingPhoneSquirt from'../images/willie_watchingPhoneSquirt.png'
import willie_sittingSerious from'../images/willie_sittingSerious.png'
import oldLady from'../images/oldLady.png'
import oldLady_frustration from'../images/oldLady_frustration.png'
import willie_watchingPhone from'../images/willie_watchingPhone.png'
import dick from'../images/dick.png'
import dick_right from'../images/dick_right.png'
import dick_rightYelling from'../images/dick_rightYelling.png'
import dick_rightTired from'../images/dick_rightTired.png'
import dick_sittingNeutral from'../images/dick_sittingNeutral.png'
import dick_sittingAngry from'../images/dick_sittingAngry.png'
import dick_sittingSleepy from'../images/dick_sittingSleepy.png'
import dick_frustrated from'../images/dick_frustrated.png'
import dick_smiling from'../images/dick_smiling.png'
import dick_embarassed from'../images/dick_embarassed.png'
import dick_neutral from'../images/dick_neutral.png'
import dick_frustratedCame from'../images/dick_frustratedCame.png'
import dick_neutralCame from'../images/dick_neutralCame.png'
import dick_smilingCame from'../images/dick_smilingCame.png'
import dick_frustratedCameSquirt from'../images/dick_frustratedCameSquirt.png'
import dick_neutralCameSquirt from'../images/dick_neutralCameSquirt.png'
import dick_smilingCameSquirted from'../images/dick_smilingCameSquirted.png'
import dick_standingNeutral from'../images/dick_standingNeutral.png'
import dick_standingEmbarassedQuestion from'../images/dick_standingEmbarassedQuestion.png'
import ursula_standingNeutral from'../images/ursula_standingNeutral.png'
import ursula_standingAngry from'../images/ursula_standingAngry.png'
import ursula_standingAngry2 from'../images/ursula_standingAngry2.png'
import ursula_sittingDisgusted from'../images/ursula_sittingDisgusted.png'
import ursula_sittingNeutral from'../images/ursula_sittingNeutral.png'
import ursula_sittingSurprised from'../images/ursula_sittingSurprised.png'
import stacy_sittingNeutral from'../images/stacy_sittingNeutral.png'
import stacy_sittingAngry from'../images/stacy_sittingAngry.png'
import ursula_sittingWhatever from'../images/ursula_sittingWhatever.png'
import ryder_standingHidden from'../images/ryder_standingHidden.png'
import ryder_standingSmiling from'../images/ryder_standingSmiling.png'
import ryder_standingLaughing from'../images/ryder_standingLaughing.png'
import ryder_standingNeutral from'../images/ryder_standingNeutral.png'
import ryder_standingEyebrowsUp from'../images/ryder_standingEyebrowsUp.png'
import ryder_standingSurprised from'../images/ryder_standingSurprised.png'
import ryder_standingQuestion from'../images/ryder_standingQuestion.png'
import ryder_standingBlushed from'../images/ryder_standingBlushed.png'
import ryder_standingDisgusted from'../images/ryder_standingDisgusted.png'
import ryder_standingSmilingTest from'../images/ryder_standingSmilingTest.png'
import ryder_standingLookingTest from'../images/ryder_standingLookingTest.png'
import ryder_standingBlushedTest from'../images/ryder_standingBlushedTest.png'
import ryder_standingSurprisedTest from'../images/ryder_standingSurprisedTest.png'
import ryder_standingNeutralTest from'../images/ryder_standingNeutralTest.png'
import ryder_standingSmilingTestAroused from'../images/ryder_standingSmilingTestAroused.png'
import ryder_standingCheckingTestAroused from'../images/ryder_standingCheckingTestAroused.png'
import ryder_laughingTestAroused from'../images/ryder_laughingTestAroused.png'
import ryder_standingDroppedSurprised from'../images/ryder_standingDroppedSurprised.png'
import ryder_standingDroppedStick from'../images/ryder_standingDroppedStick.png'
import ryder_standingNeutralShirt from'../images/ryder_standingNeutralShirt.png'
import ryder_standingEyebrowsUpShirt from'../images/ryder_standingEyebrowsUpShirt.png'
import ryder_standingQuestionShirt from'../images/ryder_standingQuestionShirt.png'
import ryder_standingSmilingShirt from'../images/ryder_standingSmilingShirt.png'
import ryder_standingLaughingShirt from'../images/ryder_standingLaughingShirt.png'
import ryder_standingDroppedBlushed from'../images/ryder_standingDroppedBlushed.png'
import howard_sittingNeutral from'../images/howard_sittingNeutral.png'
import howard_sittingSnide from'../images/howard_sittingSnide.png'
import violet_shyEyesDown from'../images/violet_shyEyesDown.png'
import violet_shy from'../images/violet_shy.png'
import violet_neutral from'../images/violet_neutral.png'

const characters = {
phoebe:{
  name:"Phoebe",
  nameRu:"Фиби",
  waving:phoebe_waving,
  neutral:phoebe_neutral,
  laughing:phoebe_laughing,
  smiling:phoebe_smiling,
  sittingDisgusted:phoebe_sittingDisgusted,
  sittingCoffeeShocked:phoebe_sittingCoffeeShocked,
  sittingNeutralCoffee:phoebe_sittingNeutralCoffee,
  sittingQuestionCoffee:phoebe_sittingQuestionCoffee,
  sittingLaughingCoffee:phoebe_sittingLaughingCoffee,
  sittingSmilingCoffee:phoebe_sittingSmilingCoffee,
  sittingDisgustedCoffee:phoebe_sittingDisgustedCoffee,
  sittingSurprisedCoffee:phoebe_sittingSurprisedCoffee,
  sittingThinkingCoffee:phoebe_sittingThinkingCoffee,
  sittingSnideCoffee:phoebe_sittingSnideCoffee,
  sittingThinkingBlushedCoffee:phoebe_sittingThinkingBlushedCoffee,
  sittingSadCoffee:phoebe_sittingSadCoffee,
  sittingAngryTearsCoffee:phoebe_sittingAngryTearsCoffee,
  sittingFrustratedTearsCoffee:phoebe_sittingFrustratedTearsCoffee,
  sittingSadTearsCoffee:phoebe_sittingSadTearsCoffee,
  sittingAngry:phoebe_sittingAngry,
  standingNeutralWild:phoebe_standingNeutralWild,
  standingLaughingWild:phoebe_standingLaughingWild,
  standingFrustratedWild:phoebe_standingFrustratedWild,
  standingEyebrowUpWild:phoebe_standingEyebrowUpWild,
  standingSmilingWild:phoebe_standingSmilingWild,
  standingEmbarassedWild:phoebe_standingEmbarassedWild,
  standingThinkingWild:phoebe_standingThinkingWild,
  standingEyebrowUpNeutralWild:phoebe_standingEyebrowUpNeutralWild,
  initialPointX:["-100","vw"],
  initialPointY:["-20","vh"],
  destinationPointX:"1",
  destinationPointY:"0",
  speed:1.2
},
empty:{
  name:"...",
  nameRu:"...",
  initialPointX:["-100","vw"],
  initialPointY:["-20","vh"],
  destinationPointX:"-15",
  destinationPointY:"-5",
  speed:1.2
},
everyone:{
  name:"Everyone",
  nameRu:"Все",
  initialPointX:["-100","vw"],
  initialPointY:["-20","vh"],
  destinationPointX:"-15",
  destinationPointY:"-5",
  speed:1.2
},
willie:{
  name:"Willie",
  nameRu:"Вилли",
  neutral:willie,
  snide:willie_snide,
  disgust:willie_disgust,
  surprised:willie_surprised,
  watchingPhone:willie_watchingPhone,
  sittingNeutral:willie_sittingNeutral,
  sittingSurprised:willie_sittingSurprised,
  sittingQuestion:willie_sittingQuestion,
  sittingLookingToTheSide:willie_sittingLookingToTheSide,
  sittingSnide:willie_sittingSnide,
  sittingSweating:willie_sittingSweating,
  watchingPhoneSquirt:willie_watchingPhoneSquirt,
  sittingSerious:willie_sittingSerious,
  neutralSquirt:willie_neutralSquirt,
  initialPointX:["-100","vw"],
  initialPointY:["-20","vh"],
  destinationPointX:"-1",
  destinationPointY:"-5",
  speed:1.2
},
oldLady:{
  name:"Old Lady",
  nameRu:"Бабуля",
  neutral:oldLady,
  frustration:oldLady_frustration,
  initialPointX:["-100","vw"],
  initialPointY:["-20","vh"],
  destinationPointX:"1",
  destinationPointY:"-10",
  speed:1.2
},
dick:{
  name:"Dick",
  nameRu:"Дик",
  neutral_right:dick_right,
  rightTired:dick_rightTired,
  rightYelling:dick_rightYelling,
  sittingNeutral:dick_sittingNeutral,
  sittingAngry:dick_sittingAngry,
  sittingSleepy:dick_sittingSleepy,
  frustrated:dick_frustrated,
  smiling:dick_smiling,
  embarassed:dick_embarassed,
  neutral:dick_neutral,
  frustratedCame:dick_frustratedCame,
  smilingCame:dick_smilingCame,
  smilingCameSquirted:dick_smilingCameSquirted,
  neutralCame:dick_neutralCame,
  neutralCameSquirt:dick_neutralCameSquirt,
  frustratedCameSquirt:dick_frustratedCameSquirt,
  standingNeutral:dick_standingNeutral,
  standingEmbarassedQuestion:dick_standingEmbarassedQuestion,
  initialPointX:["-100","vw"],
  initialPointY:["-20","vh"],
  destinationPointX:"-3",
  destinationPointY:"0",
  speed:1.2
},
ursula:{
  name:"Ursula",
  nameRu:"Урсула",
  standingNeutral:ursula_standingNeutral,
  standingAngry:ursula_standingAngry,
  standingAngry2:ursula_standingAngry2,
  sittingDisgusted:ursula_sittingDisgusted,
  sittingNeutral:ursula_sittingNeutral,
  sittingWhatever:ursula_sittingWhatever,
  sittingSurprised:ursula_sittingSurprised,
  initialPointX:["-100","vw"],
  initialPointY:["-20","vh"],
  destinationPointX:"0",
  destinationPointY:"0",
  speed:1.4
},
stacy:{
  name:"Stacy",
  nameRu:"Стейси",
  sittingNeutral:stacy_sittingNeutral,
  sittingAngry:stacy_sittingAngry,
  initialPointX:["-100","vw"],
  initialPointY:["-20","vh"],
  destinationPointX:"-25",
  destinationPointY:"-5",
  speed:1.3
},
profryderhidden:{
  name:"Someone",
  nameRu:"Кто-то",
  standingHidden:ryder_standingHidden,
  initialPointX:["-100","vw"],
  initialPointY:["-20","vh"],
  destinationPointX:"-1",
  destinationPointY:"0",
  speed:1.2
},
profryder:{
  name:"Prof. Ryder",
  nameRu:"Мисс Райдер",
  standingSmiling:ryder_standingSmiling,
  standingLaughing:ryder_standingLaughing,
  standingNeutral:ryder_standingNeutral,
  standingEyebrowsUp:ryder_standingEyebrowsUp,
  standingSurprised:ryder_standingSurprised,
  standingBlushed:ryder_standingBlushed,
  standingQuestion:ryder_standingQuestion,
  standingDisgusted:ryder_standingDisgusted,
  standingSmilingTest:ryder_standingSmilingTest,
  standingLookingTest:ryder_standingLookingTest,
  standingBlushedTest:ryder_standingBlushedTest,
  standingSurprisedTest:ryder_standingSurprisedTest,
  standingNeutralTest:ryder_standingNeutralTest,
  standingSmilingTestAroused:ryder_standingSmilingTestAroused,
  standingCheckingTestAroused:ryder_standingCheckingTestAroused,
  laughingTestAroused:ryder_laughingTestAroused,
  standingDroppedSurprised:ryder_standingDroppedSurprised,
  standingDroppedStick:ryder_standingDroppedStick,
  standingNeutralShirt:ryder_standingNeutralShirt,
  standingEyebrowsUpShirt:ryder_standingEyebrowsUpShirt,
  standingQuestionShirt:ryder_standingQuestionShirt,
  standingSmilingShirt:ryder_standingSmilingShirt,
  standingLaughingShirt:ryder_standingLaughingShirt,
  standingDroppedBlushed:ryder_standingDroppedBlushed,
  initialPointX:["-100","vw"],
  initialPointY:["-20","vh"],
  destinationPointX:"-1",
  destinationPointY:"0",
  speed:1.2
},
howard:{
  name:"Howard",
  nameRu:"Говард",
  sittingNeutral:howard_sittingNeutral,
  sittingSnide:howard_sittingSnide,
  initialPointX:["-100","vw"],
  initialPointY:["-20","vh"],
  destinationPointX:"0",
  destinationPointY:"0",
  speed:1.3
},
violet:{
  name:"Violet",
  nameRu:"Виолетта",
  neutral:violet_neutral,
  shy:violet_shy,
  shyEyesDown:violet_shyEyesDown,
  initialPointX:["-100","vw"],
  initialPointY:["-20","vh"],
  destinationPointX:"-1",
  destinationPointY:"0",
  speed:1.1
},
evilRyder:{
  name:"Evil Ryder",
  nameRu:"Райдер-Демон",
  initialPointX:["-100","vw"],
  initialPointY:["-20","vh"],
  destinationPointX:"-1",
  destinationPointY:"0",
  speed:0.8
},
angelRyder:{
  name:"Angel Ryder",
  nameRu:"Райдер-Ангел",
  initialPointX:["-100","vw"],
  initialPointY:["-20","vh"],
  destinationPointX:"-1",
  destinationPointY:"0",
  speed:1.3
},
};

export default characters;
